import { useState, useEffect } from "react";
import { useDisplayGuestCheckOUtDataQuery, useEnableGuestChechoutMutation } from "../../Services/SettingsAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo} from "@fortawesome/free-solid-svg-icons";

function AddCategory() {
    // Fetch data from API
    const { data, refetch } = useDisplayGuestCheckOUtDataQuery();

    const [extraFields, setExtraFields] = useState({
        guest_checkout_enabled: false,
    });

    useEffect(() => {
        if (data?.data) {
            setExtraFields({
                guest_checkout_enabled: data.data.guest_checkout_enabled === 1, // Convert 1 to true
            });
        }
    }, [data]);

    const [apiError, setApiError] = useState(null);
    const [EnableGuestCheckout, { isLoading }] = useEnableGuestChechoutMutation();

    // Handle checkbox change
    const handleExtraFieldChange = (e) => {
        const { name, checked } = e.target;
        setExtraFields((prevState) => ({
            ...prevState,
            [name]: checked, // Save as boolean (true/false)
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();

        // Append checkbox values (convert boolean to 1 or 0)
        formData.append("guest_checkout_enabled", extraFields.guest_checkout_enabled ? 1 : 0);

        try {
            await EnableGuestCheckout(formData).unwrap();
            alert("Settings updated successfully!");
            refetch(); // Refresh data

            setApiError(null);
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    return (
        <div>
            <h3>Enable/Disable Checkout <div className="tooltip-container">
                <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="text-warning mx-2"
                    style={{ cursor: "pointer" }}
                />
                <div className="tooltip">The guest checkout option is allowed only when the option is checked.</div>
            </div></h3>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        <div className="col-md-6 col-sm-6">
                            <div className="mb-3">
                                <input
                                    type="checkbox"
                                    id="guest_checkout_enabled"
                                    name="guest_checkout_enabled"
                                    className="form-check-input"
                                    checked={extraFields.guest_checkout_enabled}
                                    onChange={handleExtraFieldChange}
                                />
                                <label htmlFor="guest_checkout_enabled" className="form-check-label ms-2">
                                    Guest Checkout Enabled
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* API Error Message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    {/* Submit Button */}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
